"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[GlobalError]", error);
  }, [error]);

  const mailtoSubject = encodeURIComponent("Bug in Workspace");
  const mailtoBody = encodeURIComponent(error.message);
  const stackLines = (error.stack ?? "").split("\n").slice(0, 5).join("\n");

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fafaf7",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 560,
            border: "1px solid #e2e2dc",
            borderLeft: "4px solid #c0392b",
            borderRadius: 6,
            padding: "28px 32px",
            background: "#fff",
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              fontFamily: "Georgia, serif",
              fontSize: 18,
              fontWeight: 700,
              color: "#1a2a4a",
              marginBottom: 8,
            }}
          >
            Something went wrong
          </div>
          <p
            style={{
              fontSize: 13.5,
              color: "#555",
              lineHeight: 1.55,
              margin: "0 0 16px",
            }}
          >
            We logged this error so we can fix it. You can try reloading this
            view or report the bug.
          </p>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
            <button
              style={{
                padding: "7px 16px",
                background: "#1a2a4a",
                color: "#fff",
                border: "none",
                borderRadius: 4,
                fontSize: 13,
                cursor: "pointer",
              }}
              onClick={reset}
            >
              Reload this view
            </button>
            <a
              href={`mailto:support@drsleelifesciences.com?subject=${mailtoSubject}&body=${mailtoBody}`}
              style={{
                padding: "7px 16px",
                background: "transparent",
                color: "#1a2a4a",
                border: "1px solid #e2e2dc",
                borderRadius: 4,
                fontSize: 13,
                textDecoration: "none",
                display: "inline-block",
              }}
            >
              Report bug →
            </a>
          </div>
          <details style={{ fontSize: 12, color: "#888" }}>
            <summary style={{ cursor: "pointer", userSelect: "none", marginBottom: 6 }}>
              Error details
            </summary>
            <pre
              style={{
                margin: 0,
                padding: "8px 10px",
                background: "#f5f5f0",
                borderRadius: 4,
                overflowX: "auto",
                fontFamily: "ui-monospace, Menlo, monospace",
                fontSize: 11,
                lineHeight: 1.5,
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
              }}
            >
              {error.message}
              {stackLines ? `\n\n${stackLines}` : ""}
            </pre>
          </details>
        </div>
      </body>
    </html>
  );
}
